// extracted by mini-css-extract-plugin
module.exports = {"navBarTeam":"styles_navBarTeam__2N6gu","searchInput":"styles_searchInput__24rQa","chatbotsContainer":"styles_chatbotsContainer__LYmp6"};